<div class="receivables-payment-import-add-container" *ngIf="receivablesPaymentImportsRowObject" fxLayout="column" fxLayoutGap="15px" >
  <div class="status-info" *ngIf="receivablesPaymentImportsRowObject">
    <mat-form-field appearance="fill" [ngClass]="'input-color-' + receivablesPaymentImportsRowObject.status.color">
      <mat-label>Status</mat-label>
      <input matInput placeholder="Status" [disabled]="true" [value]="receivablesPaymentImportsRowObject.status?.name">
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <button (click)="sendForm()" [class.spinner]="processingRequest"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>

  </div>

  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px" style=" top: 55px;">
    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Dane wpłaty</h3>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Tytuł przelewu" [value]="receivablesPaymentImportsRowObject?.transferTitle"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Podmiot transakcji" [value]="receivablesPaymentImportsRowObject?.ownerName"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Kwota przelewu" >
                  {{(receivablesPaymentImportsRowObject.transferAmount === null ? 0 : receivablesPaymentImportsRowObject.transferAmount) | number:'1.2-2'}} zł
                </app-detail>
              </div>
            </div>

          </mat-card>
        </div>
      </div>
      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Uwagi</h3>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <mat-form-field fxFlex="100">
                  <mat-label>Uwagi</mat-label>
                  <textarea [formControl]="noteControl" matInput placeholder="Uwagi"></textarea>
                </mat-form-field>
              </div>
            </div>
          </mat-card>
        </div>
      </div>

    </div>

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Saldo</h3>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Numer salda" >
                  {{ receivablesPaymentImportsRowObject?.receivablesBalance?.recordId }}
                </app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Partner/OFWCA" >
                  <a *ngIf="receivablesPaymentImportsRowObject?.receivablesBalance?.partner"  class="default-link" [routerLink]="['/partner/szczegoly', receivablesPaymentImportsRowObject?.receivablesBalance?.partner?.uuid]">
                    {{receivablesPaymentImportsRowObject?.receivablesBalance?.partner?.shortName}}
                  </a>
                  <a *ngIf="receivablesPaymentImportsRowObject?.receivablesBalance?.ofwca"  class="default-link" [routerLink]="['/ofwca/szczegoly', receivablesPaymentImportsRowObject?.receivablesBalance?.ofwca?.uuid]">
                    {{receivablesPaymentImportsRowObject?.receivablesBalance?.ofwca?.fullName}}
                  </a>
                </app-detail>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
    </div>
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <button (click)="sendForm()" [class.spinner]="processingRequest"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
